(async () => {
    const { Core } = await importModule('Core');
    
    customElements.define('express-option-list', class extends Core {

        elements = {
            toCartButton: 'product-to-cart',
            selectedVariantPrice: '[data-selected-variant-price]',
            cartBtn: '.cart-btn'
        }
        isSorted = false;
        render() {
            this.addEventListener('change', this._onSelect.bind(this))
        }

        _onSelect(e) {
            this.selectedVariantId = e.target.value;
            this.cartBtn = e.target.dataset.cartBtnText
            this.sellingPlan = e.target.dataset.sellingPlan;
            this.fulfillDate = e.target.dataset.fulfillDate;
            this.selectedVariantPrice = e.target.dataset.price;
            this.$toCartButton.variantId = this.selectedVariantId;
            this.$toCartButton.sellingPlan = this.sellingPlan;
            this.$toCartButton.fulfillDate = this.fulfillDate;
        }

        set selectedVariantPrice(value) {
            this.$selectedVariantPrice.innerText = value
        }

        set cartBtn(value) {
            this.$cartBtn.innerText = value
        }
        
    })
})();